module.exports = __webpack_public_path__ + "img/fullscreen_layout_mobile.56f572f8.png";